import { useState } from 'react';
import { isGoogleSupportedPlatform } from '@/services/googleAuth';
import GoogleAuthFlow from './GoogleAuthFlow';

export default function GoogleContinueButton({ onSuccess }: { onSuccess: () => void }) {
  const [active, setActive] = useState(false);
  if (!isGoogleSupportedPlatform()) return null;
  return <div className="mb-2">
    <button type="button" onClick={() => setActive(true)} className="flex h-12 w-full items-center justify-center gap-3 rounded-xl border border-gray-300 bg-white text-sm font-medium text-gray-800" style={{ border: '1px solid #DADCE0' }} aria-label="使用 Google 继续">
      <img src="/google-g.png" width="20" height="20" alt="" />使用 Google 继续
    </button>
    {active && <GoogleAuthFlow onClose={() => setActive(false)} onSuccess={onSuccess} />}
  </div>;
}
